import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c6475175-9a65-4c2a-91e3-a6c8195373e3/artifacts/ccxbep84_Logo.png";
const WHATSAPP_NUMBER = "8898798857";

export const Footer = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Bunty Hair Master.");
    window.open(`https://wa.me/91${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="main-footer">
      {/* CTA Section */}
      <div className="bg-[#121212] py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white mb-4">
            Ready for Your Transformation?
          </h2>
          <p className="text-white/60 mb-8 max-w-xl mx-auto">
            Book your appointment today and experience the Bunty Hair Master difference
          </p>
          <button
            onClick={handleWhatsApp}
            className="bg-[#D4AF37] text-black font-medium px-10 py-4 rounded-none hover:bg-[#B5952F] transition-colors shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]"
            data-testid="footer-book-btn"
          >
            Book Appointment Now
          </button>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Bunty Hair Master" className="h-12 w-auto" />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Premium family hair & beauty salon in Thane West. 
              Expert styling with 20+ years of experience.
            </p>
            <a
              href="https://www.instagram.com/buntyhairmaster_salon/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F3E5AB] transition-colors"
              data-testid="footer-instagram-link"
            >
              <Instagram className="w-5 h-5" />
              <span className="text-sm">Follow on Instagram</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg text-white mb-6">Quick Links</h3>
            <nav className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Gallery", path: "/gallery" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg text-white mb-6">Services</h3>
            <nav className="space-y-3">
              {[
                "Haircuts",
                "Hair Colour",
                "Bridal Makeup",
                "Facials",
                "Hair Treatments",
              ].map((service) => (
                <Link
                  key={service}
                  to="/services"
                  className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  {service}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg text-white mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <p className="text-white/60 text-sm">
                  Shop No. 3, Vikas Palms Society,<br />
                  Dr. Ambedkar Road, Uthalsar,<br />
                  Thane West – 400606
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a 
                  href="tel:+918898798857" 
                  className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  +91 88987 98857
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <span className="text-white/60 text-sm">contact@buntyhairmaster.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <span className="text-white/60 text-sm">9:30 AM - 10:00 PM (Daily)</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Bunty Hair Master. All rights reserved.
            </p>
            <p className="text-white/40 text-sm">
              Serving Thane West since 2014
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
